import script from "./PlatMapInfoWindow.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlatMapInfoWindow.vue?vue&type=script&setup=true&lang=ts"

import "./PlatMapInfoWindow.vue?vue&type=style&index=0&id=bac405a0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bac405a0"]])

export default __exports__